import { render, staticRenderFns } from "./CarrierFormModal.vue?vue&type=template&id=60d7fc7c&scoped=true&"
import script from "./CarrierFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d7fc7c",
  null
  
)

export default component.exports